import * as React from "react"
import { useToast as useSonnerToast, toast as sonnerToast } from "sonner"

export function useToast() {
  const toastFn = (options) => {
    if (options.variant === "destructive") {
      sonnerToast.error(options.title, {
        description: options.description,
      })
    } else {
      sonnerToast.success(options.title, {
        description: options.description,
      })
    }
  }

  return {
    toast: toastFn,
  }
}
